import { atomWithReset as stateSegmentWithReset } from 'jotai/utils';
import { FileExtractionDetailsType } from '../../../types/ExtractionDetails';

export type ExtractionDetailsState = {
  // Map of fileId -> extraction details for quick lookup
  extractionDetailsMap: Map<string, FileExtractionDetailsType>;
};

export const extractionDetailsSegment =
  stateSegmentWithReset<ExtractionDetailsState>({
    extractionDetailsMap: new Map(),
  });

extractionDetailsSegment.debugLabel = 'extractionDetailsSegment';
